<template>
  <div class="row">
    <!--  岗位列表  -->
    <div class="flex xs12">
      <va-card title="岗位列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button disabled flat color="gray">课程标签：</va-button>
              <va-button flat :color="tagId !== null ? 'gray' : 'info'"
                v-on:click="handleTagIdChange(null)">全部标签</va-button>
              <va-button flat :color="tagId === val.id ? 'info' : 'gray'" :key="val.id" v-for="val in courseTags"
                v-on:click="handleTagIdChange(val.id)">{{ val.name }}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button disabled flat color="gray">发布状态：</va-button>
              <va-button v-for="status in statusOptions" :key="status.CODE" flat :color="computedColor(status.CODE)"
                @click="handleStatusChange(status.CODE)">{{ status.TEXT }}</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-input class="ma-0" :value="name" placeholder="搜索公司名称" @input="search" removable>
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{ totalCount }}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" outline small :to='{name:`uploadCareerExcel`}'>导入Execl</va-button>
              <va-button color="info" outline small @click="$router.push('saveReferral')"
                :disabled="disabledCreate">创建岗位</va-button>
            </div>
          </div>
        </div>
        <va-data-table :fields="fields" :data="referrals" :loading="loading" :totalPages="totalPages"
          @page-selected="listReferral" api-mode>
          <template slot="imgUrl" slot-scope="props">
            <img :src="props.rowData.organization.logo" class="data-table-server-pagination---avatar" alt="avatar">
          </template>

          <template slot="status" slot-scope="props">
            <va-badge :color=computeStatus(props.rowData.status).color>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="isOfficial" slot-scope="props">
            <va-badge :color=computeIsOfficial(props.rowData.isOfficial).color>
              {{ computeIsOfficial(props.rowData.isOfficial).text }}
            </va-badge>
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input v-model="props.rowData.sortNum" type="number" oninput="if(value <0)value=1" :min="1"
              v-bind:style="{ margin: '1rem auto', width: '50%' }">
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small
                @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                @click="$router.push(`updateReferral/${props.rowData.id}`)" :disabled="disabledEdit" />
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteId = props.rowData.id" :disabled="disabledDelete" />
            </va-popover>
            <va-popover message="查看报名统计" placement="top">
              <va-button flat small color="gray"
                icon="vuestic-iconset vuestic-iconset-statistics va-icon vuestic-iconset vuestic-iconset-statistics"
                :to='{ path: `/admin/applications/listAppliedJob`, query: { referralId: props.rowData.id } }' />
            </va-popover>
          </template>
        </va-data-table>

        <va-modal v-model="deleteModal" title="删除岗位" okText="提交" position="center" message="请再次确认是否要删除？"
          @ok="confirmDelete" />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import referralApi from '../../api/referral'
import tagApi from '../../api/tag'
import { SERVICE_STATUS_TYPES, TAG_TYPE } from '@/utils/constants'
import employeeApi from '@/api/employee'
import { dateFormat, formatTime } from '@/utils/common'
export default {
  data() {
    return {
      message: ['Required field'],
      // serviceId: 3,
      referrals: [],
      name: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      status: 1,
      isOfficial: false,
      statusOptions: SERVICE_STATUS_TYPES,
      courseTags: [],
      tagId: null,
      tagTypeName: '课程标签',
      permissions: [],
      disabledDelete: true,
      disabledEdit: true,
      disabledCreate: true,
    }
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:imgUrl',
          title: '公司logo',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'organization.name',
          title: '公司名称',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'position',
          title: '职位',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'releaseTime',
          title: '岗位发布时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created() {
    this.listReferralTag()
    this.listReferral()
    this.initButton()
  },
  methods: {
    formatTime(time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    initButton() {
      const id = localStorage.getItem('employeeId')
      employeeApi.listEmployeePermissions(id).then(response => {
        response.permissions.forEach(x => {
          if (x.action === 'delete_referral') {
            this.disabledDelete = false
          }
          if (x.action === 'update_referral') {
            this.disabledEdit = false
          }
          if (x.action === 'save_referral') {
            this.disabledCreate = false
          }
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    listReferral(pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
        tagId: this.tagId,
        name: this.name,
      }
      referralApi.listReferral(params).then(response => {
        this.referrals = response.referrals
        this.referrals.forEach(x => {
          x.createTime = formatTime(x.createTime)
          x.updateTime = formatTime(x.updateTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    listReferralTag() {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleStatusChange(status) {
      this.status = status
      this.listReferral()
    },
    handleTagIdChange(tagId) {
      this.tagId = tagId
      this.pageNumber = 1
      this.listReferral()
    },
    confirmDelete() {
      if (this.deleteId === null) return
      referralApi.deleteReferral(this.deleteId).then(response => {
        if (response.success === true) {
          this.listReferral(1, this.status)
        }
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    search: debounce(function (name) {
      this.name = name
      this.listReferral()
    }, 400),
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
      }
      referralApi.updateReferral(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listReferral()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computedColor: function (status) {
      return this.status === status ? 'info' : 'gray'
    },
    computeStatus: function (status) {
      const data = {
        color: 'info',
        text: '已发布',
      }
      if (status === 0) {
        data.text = '草稿中'
      }
      if (status === 2) {
        data.text = '已下架'
      }
      return data
    },
    computeIsOfficial: function (isOfficial) {
      const data = {
        color: 'gray',
        text: '否',
      }
      if (isOfficial === true) {
        data.color = 'info'
        data.text = '是'
      }
      return data
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
